import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import {
  ProjectBoard,
  SignIn,
  SignUp,
  MyProjects,
  DeletedProjects,
  EditChart,
  ChartPreview,
  PageNotFound,
  MicroClaim
} from '@pages';
import ProjectReview from '@pages/ProjectReview';
// import AddChart from '@pages/AddChart';

import PrivateRoute from './PrivateRoute';
import RoutesPath from '../constants/RoutesPath';
import AddChartNew from '@pages/AddChartNew';

const ProtectedComponent: React.FC<{ Element: React.FC<any> }> = ({
  Element
}) => (
  <PrivateRoute>
    <Element />
  </PrivateRoute>
);

const RouteLayout = () => (
  <Routes>
    <Route path={RoutesPath.SIGN_IN} element={<SignIn />} />
    <Route path={RoutesPath.SIGN_UP} element={<SignUp />} />
    <Route path={RoutesPath.PAGE_NOT_FOUND} element={<PageNotFound />} />
    {/* Micro marketplace claim page — public, unauthenticated buyers land here */}
    <Route path={RoutesPath.MICRO_CLAIM} element={<MicroClaim />} />

    <Route path={RoutesPath.CHART_PREVIEW} element={<ChartPreview />} />
    <Route path={RoutesPath.PROJECT_CHART_PREVIEW} element={<ChartPreview />} />
    <Route path={RoutesPath.PROJECT_PREVIEW} element={<ProjectBoard />} />

    <Route
      path={RoutesPath.MY_PROJECTS}
      element={<ProtectedComponent Element={MyProjects} />}
    />
    <Route
      path={RoutesPath.DELETED_PROJECTS}
      element={<ProtectedComponent Element={DeletedProjects} />}
    />
    <Route
      path={RoutesPath.PROJECT_BOARD}
      element={<ProtectedComponent Element={ProjectBoard} />}
    />

    <Route
      path={RoutesPath.EDIT_CHART}
      element={<ProtectedComponent Element={EditChart} />}
    />
    <Route
      path={RoutesPath.PROJECT_REVIEW}
      element={<ProtectedComponent Element={ProjectReview} />}
    />
    <Route
      path={RoutesPath.ADD_CHART}
      element={<ProtectedComponent Element={AddChartNew} />}
    />
    <Route
      path='*'
      element={
        <Navigate
          to='/project/my-projects'
          state={{ unmatchedPathQueryParams: location.search }}
        />
      }
    />
  </Routes>
);

export default RouteLayout;
